import { makeStyles } from '@mui/styles';

import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

import { HeaderProps } from '.';

export const muiStyles = makeStyles((theme: ApplicationMuiTheme) => ({
    globalHeaderContainer: {
        height: '65px',
        flexShrink: 0,
        backgroundColor: theme?.app?.applicationColors.enumColors.white ||
            '#FFFFFF',
        padding: '0 1rem',
        minWidth: (props: HeaderProps) => ((props.user?.IsAdmin && theme?.app?.clientTheme.layoutSettings.useGlobalHeader) ||
            (!props.user?.IsAdmin && theme?.app?.clientTheme.layoutSettings.useClientGlobalHeader) ?
            '1164px'
            : '1280px'
        )
    },
    iconsContainer: { width: 'auto' },
    nameLabel: {
        color: theme?.app.applicationColors.fontDetailColor ||
            '#4A4C50'
    },
    clickableName: { cursor: 'pointer' as const },
    logo: {
        height: '34px',
        width: 'auto'
    },
    logoDivider: {
        height: '30px',
        margin: '0 24px'
    },
    tassatLogo: {
        height: '34px',
        width: '141px',
        marginTop: '8px'
    },
    iconDivider: {
        height: '32px',
        width: '2px',
        margin: '0 1rem'
    },
    logout: {
        border: `1px solid ${theme?.app?.applicationColors.enumColors.greyLighter ||
        '#CFCFCF'}`,
        borderRadius: '23px',
        padding: '.25rem 1rem',
        letterSpacing: '.05rem',
        fontWeight: 'normal' as const,
        marginRight: '4.25rem',
        marginLeft: '1.5rem'
    },
    menuLink: {
        color: theme?.app?.applicationColors.fontColor ||
            '#202020',
        textDecoration: 'none' as const
    }
}));